module.exports = __webpack_public_path__ + "img/winner8.bb9ef121.jpg";